import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    path: String
  }

  connect() {
    window.location.href = this.pathValue;
  }
}
